import React, { useState } from "react";
import { useAddCustomer } from "../../hooks/customer/useAddCustomer";
import AlertMessage from "../../components/AlertMessage";
import Breadcrumb from "../../components/Breadcrumb";

const AddCustomer = () => {
  const {
    customer,
    handleChange,
    noEmail,
    setNoEmail,
    onSave,
    loading,
    onClear,
    message,
    showMessage,
    setShowMessage,
  } = useAddCustomer();

  // 🔹 Local state for validation messages
  const [errors, setErrors] = useState({});

  // ✅ Validation rules
  const validate = () => {
    const newErrors = {};

    if (!customer.firstName || customer.firstName.trim() === "") {
      newErrors.firstName = "First name is required";
    }

    if (!customer.lastName || customer.lastName.trim() === "") {
      newErrors.lastName = "Last name is required";
    }

    if (!customer.phoneNumber || customer.phoneNumber.trim() === "") {
      newErrors.phoneNumber = "Phone number is required";
    } else if (!/^[0-9]+$/.test(customer.phoneNumber)) {
      newErrors.phoneNumber = "Phone number must be digits only";
    } else if (customer.phoneNumber.length < 7) {
      newErrors.phoneNumber = "Phone number must be at least 7 digits";
    }
    if (!noEmail) {
      if (!customer.email || customer.email.trim() === "") {
        newErrors.email = "Email is required";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(customer.email)
      ) {
        newErrors.email = "Invalid email format";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // ✅ valid if no errors
  };
  // ✅ Handle Save click
  const handleSave = async (e) => {
    e.preventDefault();

    if (!validate()) return; // stop if invalid
    onSave();
  };
  return (
    <div className="content">
      <div className="content-block">
        <Breadcrumb parent="Customers" child="Add Customers" />
        {showMessage && (
          <AlertMessage
            key={message.text}
            setVisible={setShowMessage}
            message={message.text}
            type={message.type}
            duration={4000}
          />
        )}
        <div className="card">
          <div className="row m-3">
            <div className="col-6">
              <label className="form-label form-control-label">
                First name
              </label>
              <input
                type="text"
                name="firstName"
                className={`form-control form-input ${
                  errors.firstName ? "is-invalid" : ""
                }`}
                value={customer.firstName}
                onChange={handleChange}
              />
              {errors.firstName && (
                <div className="text-danger mt-1">{errors.firstName}</div>
              )}
            </div>

            <div className="col-6">
              <label className="form-label form-control-label">Last name</label>
              <input
                type="text"
                name="lastName"
                className={`form-control form-input ${
                  errors.lastName ? "is-invalid" : ""
                }`}
                value={customer.lastName}
                onChange={handleChange}
              />
              {errors.lastName && (
                <div className="text-danger mt-1">{errors.lastName}</div>
              )}
            </div>
          </div>

          <div className="row m-3">
            <div className="col-6">
              <label className="form-label form-control-label">
                Phone number
              </label>
              <input
                type="text"
                name="phoneNumber"
                className={`form-control form-input ${
                  errors.phoneNumber ? "is-invalid" : ""
                }`}
                value={customer.phoneNumber}
                onChange={handleChange}
              />
              {errors.phoneNumber && (
                <div className="text-danger mt-1">{errors.phoneNumber}</div>
              )}
            </div>

            <div className="col-6">
              <label className="form-label form-control-label">Email</label>
              <input
                type="text"
                name="email"
                className={`form-control form-input ${
                  errors.email ? "is-invalid" : ""
                }`}
                value={customer.email}
                onChange={handleChange}
              />
              {errors.email && (
                <div className="text-danger mt-1">{errors.email}</div>
              )}
            </div>
          </div>
          <div className="row m-3">
            <div className="col-6 m-3 form-control-container">
              <label className="form-label form-control-label mt-0">
                No Email
              </label>
              <input
                type="checkbox"
                name="noEmail"
                className="mr-2"
                checked={noEmail}
                onChange={(e) => setNoEmail(e.target.checked)}
              />
            </div>
          </div>
          <div className="row m-3">
            <div className="d-flex justify-content-end modal-footer mt-4 mb-3">
              <button
                type="submit"
                className="btn btn-secondary me-2"
                onClick={() => onClear()}
              >
                Cancel
              </button>{" "}
              <button
                type="submit"
                className="btn btn-primary"
                onClick={(e) => handleSave(e)}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCustomer;
